import { Pipe, PipeTransform } from '@angular/core';
import { IQuotationsQuotation, IQuotationVatConfiguration } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { VatService } from "app_quotation/shared/services/vat.service";

@Pipe({
    name: 'getVatConfiguration'
})
export class GetVatConfigurationPipe implements PipeTransform {

    constructor(private readonly vatService: VatService) {
    }

    public transform(value: IQuotationsQuotation): IQuotationVatConfiguration {
        return this.vatService.getVatConfiguration(value);
    }

}
